import { render, staticRenderFns } from "./Nocode.vue?vue&type=template&id=71549ba0&"
import script from "./Nocode.vue?vue&type=script&lang=js&"
export * from "./Nocode.vue?vue&type=script&lang=js&"
import style0 from "./Nocode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports